import { BehaviorSubject, distinctUntilKeyChanged, map, filter, startWith, } from 'rxjs';
const INITIAL_STATE = {
    emailNotificationSettingsDialog: {
        isOpen: false,
    },
    /** @deprecated */
    runeBridgeDialog: {
        isOpen: false,
        step: 0,
    },
    erc20BridgeDialog: {
        isOpen: false,
        step: 0,
    },
};
const store = new BehaviorSubject(INITIAL_STATE);
const dispatch = (state) => store.next(state(store.getValue()));
function select(stateKey) {
    if (!stateKey)
        return store.asObservable();
    const validStateKeys = Object.keys(store.getValue());
    if (!validStateKeys.includes(String(stateKey))) {
        throw new Error(`key: ${stateKey} does not exist on this store`);
    }
    return store.asObservable().pipe(startWith(store.getValue()), distinctUntilKeyChanged(stateKey), map(x => x === null || x === void 0 ? void 0 : x[stateKey]), filter(value => value !== null && value !== undefined));
}
const get = () => store.getValue();
// Actions
/** @deprecated */
const openRuneBridgeDialog = (step = 0) => dispatch(state => (Object.assign(Object.assign({}, state), { runeBridgeDialog: {
        isOpen: true,
        step,
    } })));
/** @deprecated */
const closeRuneBridgeDialog = () => dispatch(state => (Object.assign(Object.assign({}, state), { runeBridgeDialog: Object.assign(Object.assign({}, state.runeBridgeDialog), { isOpen: false }) })));
const openErc20BridgeDialog = (step = 0) => dispatch(state => (Object.assign(Object.assign({}, state), { erc20BridgeDialog: {
        isOpen: true,
        step,
    } })));
const closeErc20BridgeDialog = () => dispatch(state => (Object.assign(Object.assign({}, state), { erc20BridgeDialog: Object.assign(Object.assign({}, state.erc20BridgeDialog), { isOpen: false }) })));
const openEmailNotificationSettingsDialog = () => dispatch(state => (Object.assign(Object.assign({}, state), { emailNotificationSettingsDialog: {
        isOpen: true,
    } })));
const closeEmailNotificationSettingsDialog = () => dispatch(state => (Object.assign(Object.assign({}, state), { emailNotificationSettingsDialog: {
        isOpen: false,
    } })));
export const sharedState = {
    get,
    select,
    actions: {
        openEmailNotificationSettingsDialog,
        closeEmailNotificationSettingsDialog,
        openRuneBridgeDialog,
        closeRuneBridgeDialog,
        openErc20BridgeDialog,
        closeErc20BridgeDialog,
    },
};
